import React, { forwardRef, memo, useState } from 'react'
import { Heading, Box, Text, ThemeContext } from 'grommet'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import ListItem from './RTGlistItem'
import MainInput from './RTGinput'
import { List, ClearOption, More, View, Hide, Group, Grid } from 'grommet-icons'
import TooltipButton from '../Button/TooltipButton'
import { displayListModal } from '../../redux/modal/actions'
import { setPeople, setPresetGroups } from '../../redux/rtg/actions'
import ToolType from '../../utils/toolType'
import MenuIcon from '../MenuIcon'
import MoreButton from '../Button/MoreButton'
// import ChoicesListButton from '../Button/ChoicesListButton'
// import LoadSaveButton from '../Button/LoadSaveButton'
// import { device } from '../../theme/device'
import { FixedSizeList, areEqual } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import { CustomScrollbars } from '../CustomScrollbars'
import NewWrapper from '../NewWrapper'
import { useRoverFocus } from '../../hook/useRoverFocus'
import { useGeneralModal } from '../../contextHook/generalModal'
import {
  displayModifyTitleModal,
  displayCustomTeamModal,
  displayPresetGroupModal,
} from '../../redux/modal/actions'
// import { usePersistValue } from '../../hook/usePersistValue'
// import { useDarkMode } from '../../contextHook/darkMode'
import { useHideInput } from '../../contextHook/hideInput'
import InputLength from '../Common/InputLength'

const Container = styled(Box)`
  border-radius: 2rem;
  min-height: 0px;
  padding: 0.8rem 2rem;
  height: 56rem;
  box-shadow: 0px 0px 2px 1px ${props => props.theme.global.colors.border};
  @media (max-width: 1300px) {
    padding: 0.8rem;
  }
`

const Separator = styled.hr`
  background-color: transparent;
  border-top: 3px dashed ${props => props.theme.global.colors.border};
  margin: 1rem 5rem;
`

const NoWrapText = styled(Text)`
  white-space: pre;
  font-weight: 500;
`

// const ItemsBox = styled(Box)`
//   &::-webkit-scrollbar {
//     width: 5px !important;
//   }
//   &::-webkit-scrollbar-track {
//     background: white !important;
//   }
//   /* Handle */
//   &::-webkit-scrollbar-thumb {
//     background: ${props => props.theme.global.colors.scrollbar} !important;
//   }
// `

const Row = memo(
  ({ data: { data, inputFocus, hideGenderLabel }, index, style }) => {
    //memo when scrolling but not clicked
    return (
      // <div style={style}>
      <ListItem
        name={data[index].name}
        gender={data[index].gender}
        filtered={data[index].filtered}
        label={data[index]['label']} //not necessary have because previously dont have
        // key={`${inputKeyText}${index}`}
        inputFocus={inputFocus}
        hideGenderLabel={hideGenderLabel}
        index={index}
        style={style}
      />
    )
    // </div>
  },
  areEqual,
)

const innerElementType = forwardRef(({ style, ...rest }, ref) => (
  <div
    ref={ref}
    style={{
      ...style,
      paddingBottom: 6,
    }}
    {...rest}
  />
))

const RTGindex = () => {
  const people = useSelector(state => state.rtg.people)
  const keyTextRTG = useSelector(state => state.rtg.keyTextRTG)
  const [hideGenderLabel, setHideGenderLabel] = useState(false)
  const inputFocus = useRoverFocus(people.length)
  const { setConfirmModal } = useGeneralModal()
  const { setHiding } = useHideInput()
  // const { value: toolColors } = usePersistValue(
  //   state => state.settings.wheelColors.colors,
  //   ['', '', '', ''],
  // )
  // const { value: darkMode } = useDarkMode()

  const dispatch = useDispatch()

  const menuItems = [
    // {
    //   label: <NoWrapText>New List</NoWrapText>,
    //   icon: <MenuIcon icon={<New color="secondary" size="small" />} />,
    //   onClick: () => {
    //     setConfirmModal({
    //       title: 'Create a new list?',
    //       message:
    //         'All the current inputs will be deleted. If you want to keep the inputs, please save it before creating a new list.',
    //       action: () => {
    //         dispatch(setPeople([]))
    //       },
    //     })
    //   },
    // },
    {
      label: <NoWrapText>Modify Title & Desc.</NoWrapText>,
      icon: (
        <MenuIcon
          icon={
            <Text color="secondary" size="1.8rem">
              T
            </Text>
          }
        />
      ),
      onClick: () => {
        dispatch(displayModifyTitleModal(true))
      },
    },
    {
      label: <NoWrapText>Preset Group Members</NoWrapText>,
      icon: <MenuIcon icon={<Grid color="secondary" size="small" />} />,
      onClick: () => {
        dispatch(displayPresetGroupModal(true))
      },
    },
    {
      label: (
        <NoWrapText>
          {hideGenderLabel ? 'Show' : 'Hide'} Gender/Label
        </NoWrapText>
      ),
      icon: (
        <MenuIcon
          icon={
            hideGenderLabel ? (
              <Hide color="secondary" size="small" />
            ) : (
              <View color="secondary" size="small" />
            )
          }
        />
      ),
      onClick: () => {
        setHideGenderLabel(!hideGenderLabel)
      },
    },
    {
      label: <NoWrapText>Remove All Inputs</NoWrapText>,
      icon: <MenuIcon icon={<ClearOption color="reject" size="small" />} />,
      onClick: () => {
        setConfirmModal({
          title: 'Remove All Inputs?',
          message:
            'All the current inputs will be deleted. If you want to keep the inputs, please save it before proceed',
          action: () => {
            dispatch(setPeople([]))
            dispatch(setPresetGroups([]))
          },
        })
      },
    },
  ]

  const filteredLength = people.filter(choice => !choice.filtered).length
  const unfilteredLength = people.length
  return (
    // <ResponsiveContext.Consumer>
    //   {size => (
    <ThemeContext.Extend
      value={{
        // global: {
        //   colors: {
        //     brand:
        //       !darkMode || toolColors.length < 3
        //         ? toolColors[0]
        //         : toolColors[2],
        //   },
        // },
        select: {
          control: {
            extend: {
              border: '.2rem solid var(--border)',
              borderRadius: '.5rem',
            },
          },
          background: 'baseBackground',
          icons: {
            margin: {
              horizontal: '.2rem',
            },
          },
          options: {
            container: {
              pad: '.3rem .9rem',
            },
          },
        },
      }}
    >
      <Container
        // border={{
        //   color: 'border',
        //   size: '.3rem',
        //   style: 'solid',
        //   side: 'all',
        // }}
        align="stretch"
        // titleActive={titleActive}
        background="baseBackground"
      >
        <Box
          direction="row"
          justify="between"
          align="center"
          margin={{ top: '.5rem' }}
        >
          <Box direction="row" align="center" gap=".6rem">
            <Heading
              level={3}
              alignSelf="center"
              margin={{ vertical: '0px' }}
              style={{ whiteSpace: 'nowrap' }}
            >
              1. INPUTS
            </Heading>
            {people.length > 0 && (
              <InputLength
                length={
                  filteredLength === unfilteredLength
                    ? unfilteredLength
                    : `${filteredLength}/${unfilteredLength}`
                }
              />
            )}
          </Box>

          <Box direction="row" gap=".5rem">
            <TooltipButton
              icon={<View color="iconDarkLight" />}
              clicked={() => {
                setHiding(true)
              }}
              message="Hide"
              position="top"
              color=""
              padding=".8rem"
            />
            <TooltipButton
              icon={<Group color="secondary" size="small" />}
              clicked={() => dispatch(displayCustomTeamModal(true))}
              message="Set Team Names"
              position="top"
              color="secondary"
            />
            <TooltipButton
              icon={<List color="secondary" size="small" />}
              clicked={() => dispatch(displayListModal(ToolType.RTG))}
              message="View/Import Inputs"
              position="top"
              color="secondary"
            />
            <NewWrapper date="2021-07-13" top="-2px">
              <MoreButton
                menuItems={menuItems}
                icon={<More color="iconDarkLight" />}
                content="More"
              />
            </NewWrapper>
          </Box>
        </Box>
        <MainInput />
        <Separator />
        <div style={{ flex: '1 1 auto' }}>
          <AutoSizer>
            {({ height, width }) => (
              <FixedSizeList // use windowing to reduce multiple lists render time
                height={409}
                width={width} //remove scrollbars width
                itemSize={36}
                innerElementType={innerElementType}
                outerElementType={CustomScrollbars}
                itemCount={people.length}
                itemData={{
                  data: people,
                  inputFocus,
                  hideGenderLabel,
                }}
                itemKey={(index, data) => `${keyTextRTG}${index}`}
              >
                {Row}
              </FixedSizeList>
            )}
          </AutoSizer>
        </div>
        {/* <ItemsBox
            gap="xsmall"
            overflow={{ horizontal: 'hidden', vertical: 'auto' }}
            height="40rem"
          >
            {items.map((item, index) => {
              return (
                <ListItem
                  name={item.name}
                  gender={item.gender}
                  key={`${keyTextRTG}${index}`}
                  index={index}
                  size={size}
                ></ListItem>
              )
            })}
          </ItemsBox> */}
      </Container>
    </ThemeContext.Extend>
    //   )}
    // </ResponsiveContext.Consumer>
  )
}

export default memo(RTGindex)
